import { Paper } from '@mui/material';

type Props = { anchorEl: HTMLElement; children: React.ReactNode; onMouseEnter?: () => void; onMouseLeave?: () => void };

export default function SimpleMenu({ anchorEl, children, onMouseEnter, onMouseLeave }: Props) {
  const box = anchorEl.getBoundingClientRect();

  return (
    <Paper
      component="ul"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={{ position: 'fixed', zIndex: 1000, left: box.left + box.width, top: box.top }}
    >
      {children}
    </Paper>
  );
}
